/**
 * @file
 * Sliders.
 */

(function ($, Drupal, drupalSettings) {
  'use strict';

  /**
   * Set the same height for items.
   * @param items
   */
  function setSameHeight(items) {
    if (items.length) {
      var h = 0;
      $.each(items, function (index, el) {
        h = ($(this).height()) < h ? h : $(this).height();
      });

      $.each(items, function () {
        $(this).find('.eno-teaser').css('min-height', h + 'px');
      });
    }
  }

  Drupal.behaviors.sliders = {
    attach: function (context, settings) {
      $('.slider-items .field--items', context).each(function () {
        var slider = $(this);
        if (!slider.length) {
          return;
        }

        slider.slick({
          dots: true,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          appendArrows: $(this).siblings('.slider-navigation').find('.slick-slider-nav'),
          appendDots: $(this).siblings('.slider-navigation').find('.slick-slider-dots'),
          prevArrow: "<a class='btn btn-default btn-lg'><i class=\"fa-solid fa-arrow-left\"></i></a>",
          nextArrow: "<a class='btn btn-default btn-lg'><i class=\"fa-solid fa-arrow-right\"></i></a>",

          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })
          .on('setPosition', function (event, slick) {
            slick.$slides.css('height', slick.$slideTrack.height() + 'px');
          });
      });

      $('.slider-items .field--items', context).each(function () {
        setSameHeight($(this));
      });
    },
  };

})(jQuery, Drupal, drupalSettings);
